var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "20%", height: "50%" },
          attrs: {
            title: _vm.title,
            width: 800,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "机器码",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["platformKey"],
                            expression: "[ 'platformKey' ]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { readOnly: true },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "手机端激活码",
                      },
                    },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["platformValue"],
                            expression: "[ 'platformValue' ]",
                          },
                        ],
                        attrs: { rows: 2, placeholder: "请输入手机端激活码" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }